import * as Sentry from '@sentry/browser';

import { ENVIRONMENT } from '../constants';
import getEnvVariable from './environment';

const {
  SG_WEBSITE_URL,
  MAKO_URL,
  MAKO_HOST_URL,
  LABS_URL,
} = ENVIRONMENT;

function getUrlRegex(url) {
  const envUrl = getEnvVariable(url);
  if (!envUrl) {
    return '';
  }
  return new RegExp(envUrl);
}

export const telemetry = {
  load() {
    const { SIGNUP_ENV } = process.env;

    return Sentry.init({
      dsn: 'https://eb8d22221e8e4256b841d3fcea5f299d@sentry.io/1522141',
      environment: SIGNUP_ENV,
      whitelistUrls: [
        getUrlRegex(SG_WEBSITE_URL),
        getUrlRegex(MAKO_URL),
        getUrlRegex(MAKO_HOST_URL),
        getUrlRegex(LABS_URL),
      ],
    });
  },

  captureError(err, tag, value, warningLevel) {
    return Sentry.withScope((scope) => {
      scope.setTag(tag, value);
      scope.setLevel(warningLevel);
      Sentry.captureException(err);
    });
  },
};
